import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconLocalBar = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconLocalBar",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M440-200v-200L138-740q-8-8-13-18t-5-22q0-26 18-43t44-17h596q26 0 44 17t18 43q0 11-5 22t-13 18L520-400v200h160q17 0 29 12t11 28-11 29-29 11H280q-17 0-28-11t-12-29 12-28 28-12zM298-680h364l72-80H226z"
  })
}));
IconLocalBar.displayName = 'IconLocalBar';